import useInspirationZone from "../../Pregrine/InspirationZone/useInspirationZone";
import styles from "./InspirationZone.module.css";
import Shimmer from "../../components/Shimmer";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { PiCubeFocusLight } from "react-icons/pi";
import classNames from "classnames";
import PinCodeCheck from "../../components/PinCodeCheck/PinCodeCheck";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import { useState } from "react";

const InspirationZone = () => {
  const {
    data,
    loading,
    error,
    spotsData,
    setSelectedItem,
    handlePinCodeModal,
    handleCart,
    pinCodeCheckFun,
    openPinCodeModal,
    selectedItem,
    get3dModel,
    modelData,
    modelLoading,
    showModal,
    setShowModal,
  } = useInspirationZone();

  const threeDModal = (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title className={styles.modalTitle}>
          {!modelLoading && modelData && modelData.getThreeDModel
            ? modelData.getThreeDModel.label
            : null}
        </Modal.Title>
        <div className={styles["close-btn"]}>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setShowModal(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path
                fill="white"
                d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
              />
            </svg>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          {!modelLoading ? (
            modelData &&
            modelData.getThreeDModel &&
            modelData.getThreeDModel.url ? (
              <div>
                <iframe
                  // src={
                  //   "http://backend.clouddeploy.in/Hettich_Backend/pub/3dviewer/index.html?fileurl=/catalog/attribute-data/SQUATTING-fbx_2_.fbx"
                  // }
                  src={modelData.getThreeDModel.url}
                  title={modelData.getThreeDModel.label}
                  height="260"
                  width="300"
                  scrolling="no"
                  frameBorder="0"
                  className={styles.modelFrame}
                ></iframe>
              </div>
            ) : (
              <p>Sorry, No 3D Model is available for this product.</p>
            )
          ) : (
            <LoadingIndicator />
          )}
        </div>
      </Modal.Body>
      {modelData && modelData.getThreeDModel && modelData.getThreeDModel.url ? (
        <Modal.Footer className={styles.modalFooter}>
          <p>Drag to Spin</p>
        </Modal.Footer>
      ) : null}
    </Modal>
  );

  return (
    <section className="pt-3 pb-2">
      <div className="row m-0">
        <div className={`${styles.title} text-center pb-2`}>
          Inspiration Zone
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {data && data.getHotspot ? (
          <>
            <img
              src={data?.getHotspot["hotspot_data"]["hotspots_image"]}
              className={classNames("img-fluid w-100", styles.img)}
              width={1349}
              height={446}
            />
            {data && data.getHotspot && spotsData.length > 0
              ? spotsData.map((item, idx) => (
                  <DotComponent
                    productId={item.product_id}
                    name={item.name}
                    positionObject={item.positionObject}
                    number={item["hotspot_number"]}
                    key={item.id}
                    handleCart={handleCart}
                    setSelectedItem={setSelectedItem}
                    item={item}
                    get3dModel={get3dModel}
                    setShowModal={setShowModal}
                    modelLoading={modelLoading}
                    modelData={modelData}
                    productUrl={item.url_key}
                  />
                ))
              : null}
          </>
        ) : (
          <Shimmer width={"100%"} height={"446px"} />
        )}
      </div>
      {threeDModal}
      <PinCodeCheck
        openPinCodeModal={openPinCodeModal}
        pinCodeCheckFun={pinCodeCheckFun}
        handlePinCodeModal={handlePinCodeModal}
        product={selectedItem}
      />

      <div className="container">
        <div className={`row ${styles.inspire}`}>
          <div className={styles.ins_btn}>
            <Link to="/inspiration-zone-listing">
              View All
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22px"
                height="22px"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12h1m8-9v1m8 8h1M5.6 5.6l.7.7m12.1-.7l-.7.7M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0-1 3a2 2 0 0 1-4 0a3.5 3.5 0 0 0-1-3m.7 1h4.6"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

const DotComponent = ({
  positionObject,
  name,
  number,
  item,
  handleCart,
  setSelectedItem,
  productId,
  get3dModel,
  setShowModal,
  modelLoading,
  modelData,
  productUrl,
}) => {
  const handleCheck = () => {
    setSelectedItem(item);
    handleCart(item.sku);
  };

  const [showPopover, setShowPopover] = useState(false);
  const [target, setTarget] = useState(null);

  const popover = (
    <Popover id={`${productId}`} show={showPopover && target === productId}>
      <div className={styles.popoverContent}>
        <Link to={`/product/${productUrl}.html`} className={styles.productName}>
          <strong>{name}</strong>
        </Link>
        <div className={styles.actionWrapper}>
          {/* {modelLoading ? (
            <span className={styles.smallLoader}></span>
          ) : (
          )} */}
          {!modelLoading && modelData?.getThreeDModel?.url ? (
            <button
              className={styles.threeDBtn}
              title="view 3d"
              onClick={() => {
                setShowPopover(false);
                setTarget(null);
                setShowModal(true);
              }}
              disabled={
                !modelLoading &&
                modelData &&
                modelData.getThreeDModel &&
                modelData.getThreeDModel.url
                  ? false
                  : true
              }
            >
              <PiCubeFocusLight />
            </button>
          ) : (
            <span></span>
          )}
          {item.stock_status === "In Stock" ? (
            <button
              onClick={() => {
                setShowPopover(false);
                setTarget(null);
                handleCheck();
              }}
              className={styles.addToCartBtn}
            >
              Add to Cart
            </button>
          ) : (
            <button className={styles.addToCartBtn}>Out Of Stock</button>
          )}
        </div>
      </div>
    </Popover>
  );

  return (
    <>
      <OverlayTrigger
        trigger="click"
        placement={
          parseInt(positionObject?.left) > 60
            ? "left"
            : parseInt(positionObject?.right) > 60
            ? "right"
            : parseInt(positionObject?.top) > 60
            ? "top"
            : "bottom"
        }
        overlay={popover}
        show={target === productId}
        target={target}
        onToggle={() => {
          setShowPopover(false);
          setTarget(null);
        }}
        rootClose
      >
        <button
          style={{
            ...positionObject,
          }}
          className={styles.dot}
          onClick={() => {
            setShowPopover(!showPopover);
            setTarget(productId);
            get3dModel({ variables: { id: productId } });
          }}
        >
          {number}
        </button>
      </OverlayTrigger>
    </>
  );
};

export default InspirationZone;
